//
//
//
//
//
//

export default {
  name: 'DistributionBasicSetting'
};